var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import { Typography } from "antd";
import TeamComponent from "./statsTable/teamComponent/TeamComponent";
const { Text } = Typography;
const translateOr = (t, key, fallback) => {
  if (!t)
    return fallback;
  const translated = t(key);
  return translated === key ? fallback : translated;
};
const mapSubjectsToOptions = (subjects) => {
  return subjects.sort((a, b) => a.order - b.order).map((subject) => ({
    family: subject.family,
    label: subject.name,
    value: subject.subject
  }));
};
const toSortOrder = (sortDir) => sortDir === "asc" ? "ascend" : sortDir === "desc" ? "descend" : null;
const toSortDir = (sortOrder) => sortOrder === "ascend" ? "asc" : sortOrder === "descend" ? "desc" : void 0;
const mapStatsData = (data, token, t, sort = {}) => {
  var _a, _b, _c, _d, _e, _f;
  const columns = [
    {
      title: "#",
      dataIndex: "position",
      key: "position",
      className: "stats-position-cell",
      render: (position) => /* @__PURE__ */ jsx(Text, { style: { color: token.colorTextBase, fontWeight: 500 }, children: position })
    },
    {
      title: t ? t("team") : "Team",
      dataIndex: "team",
      key: "team",
      className: "stats-team-cell",
      render: (rowData) => {
        if (!rowData)
          return null;
        return /* @__PURE__ */ jsx(TeamComponent, { rowData, token });
      }
    },
    ...data.columns.filter(
      (item) => !item.isMetadata && !["teamIcon", "teamName"].includes(item.key)
    ).map((item) => __spreadValues({
      title: translateOr(t, `stats_col_${item.key}`, item.label),
      dataIndex: item.key,
      key: item.key,
      className: "stats-value-cell"
    }, item.isSortable && {
      sorter: true,
      sortDirections: ["descend", "ascend"],
      sortOrder: sort.sortBy === item.key ? toSortOrder(sort.sortDir) : null
    }))
  ];
  return {
    filterOptions: (_a = data.filters) != null ? _a : [],
    tableData: {
      columns,
      dataSource: [
        ...(_b = data.outcomeRows) != null ? _b : [],
        ...(_c = data.overUnderRows) != null ? _c : [],
        ...(_d = data.binaryRows) != null ? _d : [],
        ...(_e = data.timeBoundRows) != null ? _e : [],
        ...(_f = data.tableRows) != null ? _f : []
      ].map((row, index) => __spreadProps(__spreadValues({}, row), {
        key: row.teamId,
        position: index + 1,
        team: {
          teamIcon: row.teamIcon,
          teamName: row.teamName,
          position: index + 1
        }
      })),
      tableName: data.title
    }
  };
};
export {
  mapStatsData,
  mapSubjectsToOptions,
  toSortDir,
  translateOr
};
